import { render } from "./personData.vue?vue&type=template&id=46cf965c"
import script from "./personData.vue?vue&type=script&lang=js"
export * from "./personData.vue?vue&type=script&lang=js"

import "./personData.vue?vue&type=style&index=0&id=46cf965c&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__